import { Business } from '../../types/Business';
import { FiraBreakdownModel } from '../../types/FiraBreakdown';
import { PaymentMethodDetails } from '../../types/PaymentDetails';
import { UnsubscribeOptions } from '../../types/UnsubscribeOptions';

export abstract class IPublicService {
  abstract getGenericFees(
    sellCurrency: string,
    buyCurrency: string,
  ): Promise<{
    conversionRate: number;
    validUpto: string;
    midMarketRate: number;
  }>;

  abstract getUserUnsubscribeStatus(hash: string): Promise<boolean>;

  abstract unsubscribeEmailNotification(
    hash: string,
    reason: UnsubscribeOptions,
    feedback?: string,
  ): Promise<boolean>;

  abstract generateBankDetailsPDF(
    beneficiaryName: String,
    clientDetails: Partial<Business>,
    selectedBankDetails: PaymentMethodDetails[],
    currency?: string,
  ): Promise<Blob>;

  abstract saveContactUsFormSubmission(
    name: string,
    email: string,
    phone: string,
    message: string,
  ): Promise<boolean>;

  abstract getFIRABreakDown(firaFile: File): Promise<{
    success: boolean;
    data: FiraBreakdownModel | null;
    error: string;
  }>;

  abstract getFIRABreakDownById(requestId: String): Promise<{
    success: boolean;
    data: FiraBreakdownModel | null;
    error: string;
  }>;
}
